import { combineEpics } from "redux-observable";

import loginWithFirebase from "./login/epics/loginWithFirebase";
import logoutOfFirebase from "./login/epics/logoutOfFirebase";
import loadPath from "./data/epics/loadPath";

import synchronizeRegistration from "./registration/epics/synchronizeRegistration";
import createRegistration from "./registration/epics/createRegistration";
import updateRegistration from "./registration/epics/updateRegistration";
import setCurrentRegistration from "./registration/epics/setCurrentRegistration";
import completeRegistration from "./registration/epics/completeRegistration";
import cancelRegistration from "./registration/epics/cancelRegistration";

import groupRegistration from "./staff/epics/groupRegistration";
import assignUserToLane from "./staff/epics/assignUserToLane";
import changeLane from "./staff/epics/changeLane";
import backToQueue from "./staff/epics/backToQueue";
import updateQueueItem from "./staff/epics/updateQueueItem";
import deleteQueueItem from "./staff/epics/deleteQueueItem";
import quickAddCustomer from "./staff/epics/quickAddCustomer";
import synchronizeCustomers from "./staff/epics/synchronizeCustomers";
import unGroupRegistration from "./staff/epics/unGroupRegistration";
import updateQueueOrder from "./staff/epics/updateQueueOrder";

import searchCustomer from "./customer/epics/searchCustomer";
import saveCustomer from "./customer/epics/saveCustomer";
import exportCustomer from "./customer/epics/exportCustomer";
import saveIssue from "./customer/epics/saveIssue";
import deleteIssue from "./customer/epics/deleteIssue";

export default combineEpics(
  loginWithFirebase,
  logoutOfFirebase,
  loadPath,
  synchronizeRegistration,
  createRegistration,
  setCurrentRegistration,
  updateRegistration,
  completeRegistration,
  cancelRegistration,
  groupRegistration,
  unGroupRegistration,
  updateQueueOrder,
  assignUserToLane,
  changeLane,
  backToQueue,
  updateQueueItem,
  deleteQueueItem,
  quickAddCustomer,
  synchronizeCustomers,
  searchCustomer,
  saveCustomer,
  exportCustomer,
  saveIssue,
  deleteIssue
);



// WEBPACK FOOTER //
// ./src/epics.js